module.exports = __webpack_public_path__ + "img/trade-img-ueasy.d2748faf.png";